import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createEventService, type CreateEventPayload } from '@/services/events'

export const useCreateEvent = (agendaId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: CreateEventPayload) => createEventService(agendaId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['agendas', agendaId, 'events'] })
    },
  })
}
